// import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import MyCvLoader from "./MyCvLoader";
import { getMyCV, replaceCV } from "../../../api/apiServices";
import { useMutation } from "react-query";
import Swal from "sweetalert2";

export const ReplaceCV = ({ member }) => {
	const navigate = useNavigate();

	const [data, setData] = useState({
		pf_number: "",
		curriculum_vitae: "",
		selectedFile: null,
		previewUrl: "",
	});
	useEffect(() => {
		data.selectedFile &&
			setData((prevData) => ({
				...prevData,
				previewUrl: URL.createObjectURL(data.selectedFile),
			}));
	}, [data.selectedFile]);

	useEffect(() => {
		member?.pfNumber &&
			getMyCV(member?.pfNumber).then((res) => {
				setData((prevData) => ({
					...prevData,
					pf_number: res.myCV?.pf_number,
					curriculum_vitae: res.myCV?.curriculum_vitae,
				}));
			});
	}, [member?.pfNumber]);

	const handleSubmit = (e) => {
        e.preventDefault();
        
        if ( !data.selectedFile) {
            Swal.fire({
                title: "Oooops!",
                text: "Please upload your new CV or Cancel!",
                icon: "warning",
                width: 400,
                padding: "3em",
            }).then((result) => {
                if (result.isConfirmed) {
                    return false
                }
            });
        } else {
            let formData = new FormData();
    
            formData.append("file", data.selectedFile);
            formData.set("pf_number", data.pf_number);
            replaceCVMutation.mutate(formData);
            
        }

	};

	const replaceCVMutation = useMutation(replaceCV, {
        onSuccess: async (res) => {
            console.log(res)
			if (!res.success) {
                toast.error(res.message, {
                    duration: 5000,
                    className: "toast-message",
                })
				return false;
			} else {
                toast.success(res.message, {
                    duration: 5000,
                    className: "toast-message",
                })
                // navigate("/home");
			}
		},
		onError: async (err) => {
			toast.error(err.message, {
				duration: 5000,
				className: "toast-message",
			});
		},
	});

	const handleCancel = () => {
		navigate("/home");
	};

	const myCv = (
		<>
			<form onSubmit={handleSubmit}>
				<fieldset className="col-sm-6">
					<legend>PREVIOUS CV </legend>
					<div className="cv-box">
						<a
							rel="noreferrer"
							target="_blank"
							href={`/uploads/CVs/${data.curriculum_vitae}`}
						>
							<h3 className="cv-title">
								<i className="fa fa-eye"></i>
								&nbsp;&nbsp; Click to View CV
							</h3>
						</a>
					</div>
				</fieldset>
				<fieldset className="col-sm-6">
					<legend>UPLOAD NEW CV </legend>
					<label htmlFor="photo" className="col-sm-4 label-text">
						Upload New CV<span>&nbsp;&nbsp;*</span>
					</label>
					<div className="col-sm-8">
						<MyCvLoader
							name={"selectedFile"}
							data={data}
							setData={setData}
						/>
					</div>
					{data.previewUrl && (
						<>
							<label
								htmlFor="filename"
								className="col-sm-4 label-text"
							>
								File Name<span>&nbsp;&nbsp;*</span>
							</label>
							<div className="col-sm-8">
								<span
									style={{
										fontSize: "14px",
										fontWeight: "bold",
										color: "blue",
										cursor: "pointer",
									}}
								>
									{" "}
									{data.selectedFile.name}{" "}
								</span>
							</div>
						</>
					)}
				</fieldset>

				<fieldset className="col-sm-12">
					<div className="panel-footer">
						<div className="row">
							<div className="col-sm-2">
								<button
									type="submit"
									className="btn btn-success btn-block"
								>
									Replace
								</button>
								&nbsp;&nbsp;&nbsp;&nbsp;
							</div>
							<div className="col-sm-2">
								<button
									type="button"
									onClick={handleCancel}
									className="btn btn-danger btn-block"
								>
									Cancel
								</button>
							</div>
						</div>
					</div>
				</fieldset>
			</form>
		</>
	);

	return (
		<>
			<Toaster toastOptions={{ position: "top-center" }} />
			<section className="content-header">
				<h1>
					<i className="fas file"></i> Curriculum Vitae
				</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>My Curriculum Vitae</span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">{myCv}</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
